import React from "react";
import SectionWrapper from "../components/SectionWrapper";

const BlogsPage = () => {
  return (
    <div className="mt-16 py-16">
      <div
        className="relative flex flex-col items-center justify-center h-[60vh] text-center px-4 
                  bg-gradient-to-br from-maroon/5 via-white to-gray-100 
                  overflow-hidden"
      >
        {/* Animated Background Glow */}
        <div className="absolute w-[250px] h-[250px] bg-maroon/20 rounded-full blur-3xl animate-pulse"></div>

        {/* Floating “Coming Soon...” Text */}
        <h1
          className="text-4xl md:text-6xl font-bold text-maroon mb-4 
                   animate-fade-in-up drop-shadow-lg"
        >
          Coming Soon...
        </h1>

        {/* Sub Text */}
        <p className="text-gray-600 text-lg animate-fade-in delay-300">
          We’re working hard to bring you something amazing!
        </p>
      </div>
    </div>
  );
};

export default BlogsPage;
